export const getShopId = state => state.getIn(['registration', 'shopId']);
export const getShopName = state => state.getIn(['registration', 'shopName']);
export const getCity = state => state.getIn(['registration', 'city']);
export const getStep = state => state.getIn(['registration', 'step']);
export const getCardNumber = state => state.getIn(['registration', 'cardNumber']);
export const getPhoneNumber = state => state.getIn(['registration', 'phoneNumber']);
export const getTermsConsent = state => state.getIn(['registration', 'termsAccepted']);
